import { render, staticRenderFns } from "./AssignmentSelectionModal.vue?vue&type=template&id=01e82efc&scoped=true"
import script from "./AssignmentSelectionModal.vue?vue&type=script&lang=js"
export * from "./AssignmentSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSelectionModal.vue?vue&type=style&index=0&id=01e82efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e82efc",
  null
  
)

export default component.exports